import React from "react";

import { shortenAddress } from "../Utils/Helpers";

import {
  Drawer,
  Heading,
  Text,
  Button,
  Box,
  Stack,
  CloseButton,
} from "@chakra-ui/react";
import { AlertTriangle } from "lucide-react";
import { BoldText } from "../Components/UI/UIHelpers";

interface IPreflightModalTransferProps {
  open: boolean;
  close: () => void;
  sender: string;
  receiver: string;
  value?: number;
  tokenId?: string;
  tokenSymbol: string;
  sourceNetwork: string;
  targetNetwork: string;
  start: () => void;
}

const PreflightModalTransfer: React.FC<IPreflightModalTransferProps> = ({
  open,
  close,
  receiver,
  sender,
  sourceNetwork,
  targetNetwork,
  tokenSymbol,
  value,
  tokenId,
  start,
}: IPreflightModalTransferProps) => {
  return (
    <Drawer.Root
      open={open}
      onOpenChange={({ open: o }) => !o && close()}
      placement="start"
    >
      <Drawer.Backdrop />
      <Drawer.Positioner>
        <Drawer.Content minWidth="350px" p="32px">
          <Drawer.CloseTrigger asChild position="absolute" top="4" right="4">
            <CloseButton />
          </Drawer.CloseTrigger>
          <Drawer.Header p="0px" mb="32px" fontSize="32px">
            Pre-flight check
          </Drawer.Header>
          <Drawer.Body p="0px">
            <Stack gap="32px" direction="column">
              <Heading fontSize="20px">
                Please be advised this is an experimental application:
              </Heading>
              <Stack gap="24px" direction="column">
                <Stack gap="16px" direction="row">
                  <AlertTriangle size={16} style={{ marginTop: "5px" }} />
                  <Text>
                    You will not be able to cancel the transaction once you
                    submit it.
                  </Text>
                </Stack>

                <Stack gap="16px" direction="row">
                  <AlertTriangle size={16} style={{ marginTop: "5px" }} />
                  <Text>
                    Your transaction could get stuck for an indefinite amount of
                    time.
                  </Text>
                </Stack>

                <Stack gap="16px" direction="row">
                  <AlertTriangle size={16} style={{ marginTop: "5px" }} />
                  <Text>
                    Funds cannot be returned if they are sent to the wrong
                    address.
                  </Text>
                </Stack>
              </Stack>
              <Text>
                I agree and want to send{" "}
                {value && (
                  <BoldText>
                    {value} {tokenSymbol}{" "}
                  </BoldText>
                )}
                {tokenId && (
                  <>
                    <BoldText>{tokenSymbol}</BoldText> with id{" "}
                    <BoldText>{tokenId}</BoldText>{" "}
                  </>
                )}
                from <BoldText>{shortenAddress(sender)}</BoldText> on{" "}
                <BoldText>{sourceNetwork}</BoldText> to{" "}
                <BoldText>{shortenAddress(receiver)}</BoldText> on{" "}
                <BoldText>{targetNetwork}</BoldText>.
              </Text>
              <Box>
                <Button onClick={start} size="lg">
                  Start Transfer
                </Button>
              </Box>
              <Box>
                <Button variant="outline" onClick={close}>
                  Back
                </Button>
              </Box>
            </Stack>
          </Drawer.Body>
        </Drawer.Content>
      </Drawer.Positioner>
    </Drawer.Root>
  );
};

export default PreflightModalTransfer;
